/**
 * Share, as the remodelled landing page (landing.V2) has it: posts only. The
 * four networks' badges (Instagram, Facebook, Pinterest, TikTok) in their own
 * colours, the worry that one good post takes hours, "Share a plant's season
 * in seconds.", and a phone holding the owner's real Arrange screen
 * (public/landing/share-arrange.png).
 *
 * The friend-credit line is gone, and the garden-page line moved to the
 * gardens section.
 *
 * Words (en/es): landing.v2.share.*.
 *
 * @module ShareV2
 */

import React from 'react';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { FeatureBlock } from '../components/FeatureBlock';
import { PhoneFrame } from '../components/PhoneFrame';
import { SocialBadges } from '../components/SocialBadges';

/** The share section. */
export const ShareV2: React.FC = () => {
  const { reactTranslate: t } = useTranslation();
  return (
    <FeatureBlock
      icon={<SocialBadges />}
      quote
      pain={t('landing.v2.share.pain')}
      title={t('landing.v2.share.title')}
      line={t('landing.v2.share.body')}
      evidence={(
        <PhoneFrame statusBar={false}>
          <img src="/landing/share-arrange.png" alt={t('landing.v2.share.arrangeAlt')} loading="lazy" className="block w-full" />
        </PhoneFrame>
      )}
    />
  );
};
